console.log(' >>>>>>>>>>>>>>>> process.env.REACT_APP_API_BASE_URL', process.env.REACT_APP_API_BASE_URL);
console.log(' >>>>>>>>>>>>>>>> process.env.DOMAIN', process.env.DOMAIN);
const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
};

export default config;
